export const CREATE_CHENILLARD = "CREATE_CHENILLARD";
export const RETRIEVE_CHENILLARDS = "RETRIEVE_CHENILLARDS";
export const UPDATE_CHENILLARD = "UPDATE_CHENILLARD";
export const DELETE_CHENILLARD = "DELETE_CHENILLARD";
export const DELETE_ALL_CHENILLARDS = "DELETE_ALL_CHENILLARDS";

